import type { JSX } from 'react'
import { cn } from '#src/cn.ts'

export function IconStandingOrder({
  className,
}: {
  className?: string
}): JSX.Element {
  return (
    <svg
      className={cn('size-4 shrink-0', className)}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 13 13"
      fill="none"
    >
      <path
        d="M6.49961 9.2086L5.41627 10.2919M5.41627 10.2919L6.49961 11.3753M5.41627 10.2919H10.2913C10.4638 10.283 10.6318 10.233 10.7811 10.146C10.9304 10.0589 11.0567 9.93744 11.1495 9.79165C11.2422 9.64586 11.2988 9.47999 11.3144 9.30789C11.33 9.13579 11.3042 8.96246 11.2392 8.80235L10.9413 8.26069M4.62328 5.9586L4.22678 4.47877M4.22678 4.47877L2.74694 4.87527M4.22678 4.47877L1.78927 8.70052C1.71075 8.85439 1.67017 9.02481 1.67091 9.19755C1.67165 9.3703 1.71368 9.54037 1.79352 9.69356C1.87335 9.84676 1.98866 9.97864 2.12982 10.0782C2.27099 10.1778 2.43392 10.2421 2.60502 10.2659L3.22306 10.2789M8.37594 5.9586L9.85577 6.3551M9.85577 6.3551L10.2523 4.87527M9.85577 6.3551L7.41827 2.13335C7.32424 1.98842 7.19692 1.86808 7.04692 1.78237C6.89692 1.69666 6.72859 1.64807 6.55599 1.64065C6.38339 1.63323 6.21152 1.66719 6.05472 1.73971C5.89791 1.81223 5.76073 1.92119 5.6546 2.05752L5.33448 2.58618"
        stroke="#509ABA"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
